var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.512,
    height: 150,
    viewBox: "0 0 117.512 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c30b70;}.b{fill:#3f3d56;}.c{fill:#a0616a;}.d{fill:#2f2e41;}.e{fill:#ec008c;}.f,.k{fill:#2e2e2d;}.f{opacity:0.2;}.g{fill:#e6e6e6;}.h{fill:#fff;}.i{fill:url(#a);}.j{fill:#fbae47;}.l{fill:#ec168c;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.806,
    y1: 0.5,
    x2: 0.232,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbae47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec008c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M555.074,325.869l-7.139.275-5.492-21.967-1.373-27.184h0a5.7,5.7,0,0,1,4.949,4.942l2.465,19.5Z",
    transform: "translate(-499.922 -249.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M70.771,534.121H0v-.578H70.876Z",
    transform: "translate(0 -387.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M78.172,391.963l-4.119.275.549-43.11h10.16Z",
    transform: "translate(-53.719 -253.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M150.172,391.963l-4.119.275.549-43.11,6.571,0Z",
    transform: "translate(-105.949 -253.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M475.295,502.5a14.441,14.441,0,0,1-12.221.209l-2.057-49.359-5.892,48.927a30.181,30.181,0,0,1-13.054.223c1.011-7.329,5.329-51.95,4.943-60.134l28.831-1.373Z",
    transform: "translate(-426.679 -368.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M461.382,687.975h0a4.166,4.166,0,0,1-4.159-4.412l.4-6.714c1.6-2.869,3.542-2.88,5.806-.207l1.916,5.876a4.166,4.166,0,0,1-3.961,5.457Z",
    transform: "translate(-437.666 -537.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M532.382,687.975h0a4.166,4.166,0,0,1-4.159-4.412l.4-6.714c1.6-2.869,3.542-2.88,5.806-.207l1.916,5.876a4.166,4.166,0,0,1-3.961,5.457Z",
    transform: "translate(-489.171 -537.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 7.963,
    cy: 7.963,
    r: 7.963,
    transform: "translate(29.67 3.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M487.976,238.9l-12.905-5.217c3.089-1.514,5.186-4.327,6.865-7.688H487.7C487.426,231.122,487.2,236.13,487.976,238.9Z",
    transform: "translate(-450.618 -212.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M481.9,305.086l-30.753.824a367.741,367.741,0,0,0-1.824-45.523,8,8,0,0,1,5.153-8.274l2.986-1.12,12.082,3.295,5.7,4.372a5.837,5.837,0,0,1,2.264,5.038C476.648,276.3,478.575,290.338,481.9,305.086Z",
    transform: "translate(-431.913 -230.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M569.864,459.513h0a3.2,3.2,0,0,1-3.368-2.844l-.68-6.121,3.633-1.012,3,5.173a3.2,3.2,0,0,1-2.585,4.8Z",
    transform: "translate(-516.446 -374.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M81.828,129.628l-.275,18.122L93.635,168.07,82.926,147.2Z",
    transform: "translate(-59.16 -94.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M69.277,229.313l7.161,12.305-2.538-.137Z",
    transform: "translate(-50.255 -166.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M512.372,397.458a1.262,1.262,0,0,0-1.26,1.26v78.123a1.262,1.262,0,0,0,1.26,1.26h80.643a1.261,1.261,0,0,0,1.26-1.26V398.718a1.261,1.261,0,0,0-1.26-1.26Z",
    transform: "translate(-476.763 -336.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M522.612,483.286H599.46V408.958H522.612Z",
    transform: "translate(-485.105 -345.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M545.082,452.083c-.513,0-.93.735-.93,1.638s.417,1.638.93,1.638h35.049c.513,0,.93-.735.93-1.638s-.417-1.638-.93-1.638Z",
    transform: "translate(-500.731 -369.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M545.082,488.795c-.513,0-.93,1.983-.93,4.42s.417,4.42.93,4.42h35.049c.513,0,.93-1.983.93-4.42s-.417-4.42-.93-4.42Z",
    transform: "translate(-500.731 -378.301)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M545.082,525.083c-.513,0-.93.735-.93,1.638s.417,1.638.93,1.638h35.049c.513,0,.93-.735.93-1.638s-.417-1.638-.93-1.638Z",
    transform: "translate(-500.731 -422.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M545.082,561.795c-.513,0-.93.735-.93,1.638s.417,1.638.93,1.638h35.049c.513,0,.93-.735.93-1.638s-.417-1.638-.93-1.638Z",
    transform: "translate(-500.731 -468.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M735.525,452.476a1.638,1.638,0,0,0,0,3.276h6.552a1.638,1.638,0,1,0,0-3.276Z",
    transform: "translate(-638.367 -369.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M735.525,488.476a1.638,1.638,0,0,0,0,3.276h6.552a1.638,1.638,0,1,0,0-3.276Z",
    transform: "translate(-638.367 -395.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M735.525,524.476a1.638,1.638,0,0,0,0,3.276h6.552a1.638,1.638,0,1,0,0-3.276Z",
    transform: "translate(-638.367 -421.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M735.525,560.476a1.638,1.638,0,0,0,0,3.276h6.552a1.638,1.638,0,1,0,0-3.276Z",
    transform: "translate(-638.367 -447.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 61.781,
    height: 0.549,
    transform: "translate(43.536 129.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M499.445,457.03h0a3.2,3.2,0,0,1-4.2-1.332l-2.979-5.39,2.965-2.33,4.757,3.624a3.2,3.2,0,0,1-.542,5.428Z",
    transform: "translate(-463.091 -373.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M454.577,309.714l-6.041,3.295-13.729-23.614-1.582-20.766a10.846,10.846,0,0,1,6.941-10.954l1.78-.681,1.1,31.3Z",
    transform: "translate(-420.24 -235.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M507.809,179.41l.089,1.328-.684-1.823a10.613,10.613,0,0,0-5.9-2.023h0a7.821,7.821,0,0,0-8.32,9.843l.1,1.141,2.2-3.02h0a7.722,7.722,0,0,1,7.434-1.667,13.1,13.1,0,0,1,2.751,1.2,15.114,15.114,0,0,1,3.544,2.94l.191-1.3A5.283,5.283,0,0,0,507.809,179.41Z",
    transform: "translate(-463.42 -176.866)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(44 69.987)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBill);
export default __webpack_public_path__ + "static/media/menu-bill.3aa542362e13edc67ceeafaa46d95924.svg";
export { ForwardRef as ReactComponent };